import { NativeInvoiceFormRawState } from "./nativeInvoiceFormTypes";

function stableStringify(value: NativeInvoiceFormRawState): string {
    return JSON.stringify(value, (key, v) => {
        if (key === "logoPreviewUrl") {
            return undefined;
        }
        if (v && typeof v === "object" && !Array.isArray(v)) {
            return Object.fromEntries(
                Object.entries(v).sort(([left], [right]) =>
                    left.localeCompare(right),
                ),
            );
        }
        return v;
    });
}

// A pure fingerprint of the RAW editable form state, used to detect unsaved
// changes for the close-confirmation guard. It is deliberately distinct from
// the save-dedup hash (which hashes the resolved API draft body):
//
// - Raw state stores soft-default fields as `*Override` values that are null
//   while still deriving from live props/entity. Because we serialize the raw
//   state (not the resolved state), an async default arriving — the suggested
//   invoice number, the current user's email — never flips the form to dirty:
//   the override stays null, so the fingerprint is unchanged.
// - All user-authored content participates: header fields, lines, per-line
//   coding (classIds / accrual / receivables live on each line row), and the
//   design fields (logoPath, backgroundColor, fontFamily).
// - `logoPreviewUrl` is excluded: it is a transient display URL from the upload
//   endpoint, never persisted, so it must not mark the form dirty.
//
// Object keys are sorted before stringify so key-order differences (e.g. from
// spread/rehydrate) cannot make a reverted form look dirty.
export function buildNativeInvoiceDirtyFingerprint(
    raw: NativeInvoiceFormRawState,
): string {
    return stableStringify(raw);
}
